import React from 'react';
import PropTypes from 'prop-types';
import { useColors } from '../../../hooks/useColors';
import { useTextReplacement } from '../../../hooks/useTextReplacement';

const ConfirmDialog = ({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel
}) => {
  const { semantic } = useColors();
  const { replace } = useTextReplacement();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[300] overflow-y-auto">
      <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          onClick={onCancel}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Escape' || e.key === 'Enter') {
              onCancel();
            }
          }}
          aria-label={replace('Close dialog')}
        ></div>

        <div className={`relative transform overflow-hidden rounded-lg ${semantic.contentCardBg} text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg`}>
          <div className="px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
                <h3 className={`text-lg font-semibold leading-6 ${semantic.contentCardHeading} mb-2`}>
                  {replace(title)}
                </h3>
                <div className="mt-2">
                  <p className={`text-sm ${semantic.contentCardText}`}>
                    {replace(message)}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className={`${semantic.sectionBg} px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 gap-2`}>
            <button
              type="button"
              onClick={onConfirm}
              className={`w-full sm:w-auto rounded-md bg-red-600 px-3 py-2 text-sm font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 ${semantic.ctaButtonPrimary}`}
            >
              {replace(confirmText)}
            </button>
            <button
              type="button"
              onClick={onCancel}
              className={`mt-3 sm:mt-0 w-full sm:w-auto rounded-md ${semantic.buttonSecondary} px-3 py-2 text-sm font-medium shadow-sm ring-1 ring-inset ${semantic.formBorder} hover:${semantic.sectionBg} focus:outline-none focus:ring-2 focus:ring-accent-500`}
            >
              {replace(cancelText)}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

ConfirmDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default ConfirmDialog;

